import { Component, ElementRef, Inject, OnInit, ViewChild, ViewContainerRef } from '@angular/core';

import { CDSMask } from '@app/utils/cds-mask';
import { ToastrService } from 'ngx-toastr';

import { IdDescricao } from '@app/models/util/id-descricao';
import { Filtros } from './filtros';

import { ConsultasService } from '@app/services/consultas.service';
import { RelatorioService } from '@app/services/relatorio.service';
import debounce from '@app/utils/debounce';
import { UtilitarioService } from '@app/services/utilitario.service';

@Component({
  selector: 'app-rel-extrato-participante',
  templateUrl: 'extrato-participante.component.html',
  styleUrls: ['./extrato-participante.component.scss']
})
export class RelatorioExtratoParticipanteComponent implements OnInit {

  rel: any[];

  totalCredito = 0;
  totalDebito = 0;
  totalSaldo = 0;

  nomeParticipanteRelatorio: string = "";
  
  lstUnidades: IdDescricao[] = [];
  lstParticipante: Array<any> = [{}];
  filtros: Filtros = new Filtros();
  cdsMask: CDSMask = new CDSMask();
  pesquisando: boolean;
  showTable: boolean = false;

  dataRelatorio: Date;

  constructor(
    private relatorioService: RelatorioService,
    private consultasService: ConsultasService,
    @Inject(ToastrService) public toastr: ToastrService,
  ) {

  }

  ngOnInit() {
    this.consultasService.consultar('UNIDADE_S_RATEIO').toPromise().then(data => this.lstUnidades = data);
  }

  pesquisar() {
    this.dataRelatorio = new Date();
    if (this.filtros.ParticipanteId === undefined || this.filtros.ParticipanteId === 0) {
      this.toastr.error('Participante não informado', 'Aviso!');
    } else {
      this.pesquisando = true;
      this.relatorioService.extratoParticipante(this.filtros)
        .toPromise().then((data) => {
          this.rel = data;
          this.somaSaldo();
          this.pesquisando = false;
          if (this.rel.length === 0) {
            this.toastr.info("Busca não encontrou resultados");
            this.showTable = false;
          } else {
            this.showTable = true;
          }
        }, erro => {
          this.pesquisando = false
          this.toastr.warning("Realize a pesquisa novamente.")
        });
      //  () => this.pesquisando = false);
    }
  }

  public somaSaldo(): void {
    let aux = 1;
    let saldo = 0;
    for (let i = 0; i < this.rel.length; i++) {
      aux = this.rel[i].Credito_Debito === 'D' ? -1 : 1;
      saldo += aux * this.rel[i].Valor;
      this.rel[i].Saldo = saldo;
    }
    this.totalCredito = 0; this.totalDebito = 0;
    this.rel.filter(x => x.Credito_Debito === 'C').forEach(element => { this.totalCredito += element.Valor; });
    this.rel.filter(x => x.Credito_Debito === 'D').forEach(element => { this.totalDebito += element.Valor; });
    this.totalSaldo = this.totalCredito - this.totalDebito;
  }

  _debounce: any;
  _pesquisa: any;


  @ViewChild('relatorio') relatorio: ElementRef;
  public imprimir() {
    let conteudo = document.getElementById("extratoDeParticipante").innerHTML;
    UtilitarioService.imprimirHTML(conteudo, "Relatorio extrato participante", this.montaImpressaoFiltros());
  }

  private montaImpressaoFiltros(){
    let objetoFiltros = new Map<string, string>();

    adicionaMapValido('Emitido em', this.dataRelatorio.toLocaleString());
    
    parseDateAdicionaMap('Vencimento Inicial', this.filtros.DataInicial);
    parseDateAdicionaMap('Vencimento Final', this.filtros.DataFinal);
    
    obtemDescricaoAdicionaMap('Unidade', this.lstUnidades, this.filtros.UnidadeId);

    adicionaMapValido('Participante', this.nomeParticipanteRelatorio);

    function obtemDescricaoAdicionaMap(chave: string, listaItens: IdDescricao[], idItem: number){
      if(idItem){
        let valor = listaItens.find(x => x.Id === idItem).Descricao;
        objetoFiltros.set(chave, valor);
      } 
    }

    function parseDateAdicionaMap(tipoData: string, data: string){
      if(data && data.indexOf('-') >= 0){
        let dataPartes = data.split('-');
        let dataMontada = dataPartes[2] + '/' + dataPartes[1] + '/' + dataPartes[0];
        objetoFiltros.set(tipoData, dataMontada);
      }
    }

    function adicionaMapValido(chave: string, valor: any){
      if(valor){
        objetoFiltros.set(chave, valor.toString());
      }
    }

    let stringHtml = '';

    objetoFiltros.forEach((valor, chave) => {
      stringHtml += `<tr><td>${chave}</td><td>${valor}</td></tr>`;
    })
    return stringHtml;
  }
}

